import React, { useEffect } from 'react';
import { validationProfile } from 'consts/validateSchema';
import { useDispatch } from 'react-redux';
import { Formik, Form } from 'formik';

import NewDesign from 'components/NewDesign';
import Profile from 'pages/Settings/Tabs/Profile';
import actions from 'redux/actions';
import getUser from 'redux/selector/getUser';
import UserModel from 'models/user.model';
import useResponsive from 'hooks/useResponsive';
import CheckingBillingInformationProvider, {
  useCheckingBillingInformationProvider,
} from 'providers/CheckingBillingInformationProvider';
import { CommonIcons } from 'components/Icons';
import UserServices from 'services/UserServices';
import { AppRoutes } from 'consts/routesPath';
import { get } from 'lodash';

const propTypes = {};

const { updateProfileUser } = actions;

const WarningUpdateBillingInfoPage = (props) => {
  //! State
  const dispatch = useDispatch();
  const userInfo = getUser();
  const { isMobile } = useResponsive();

  const checkingBillingInformationHandler = useCheckingBillingInformationProvider();

  //! Function
  const onSubmit = (values, { setSubmitting }) => {
    dispatch(
      updateProfileUser({
        ...values,
        callbacks: {
          onSuccess: () => {
            checkingBillingInformationHandler.refreshBillingInformation();
            setSubmitting(false);
          },
          onFailed: () => {
            setSubmitting(false);
          },
        },
      })
    );
  };

  const logout = () => {
    UserServices.clearUserCached();
    window.location.href = AppRoutes.Login;
  };

  console.log({ userInfo });
  const notEnoughField = !get(userInfo, 'info.extraInfo.entityName');
  useEffect(() => {
    if (userInfo.isLogged) {
      if (notEnoughField) {
        return;
      }

      if (checkingBillingInformationHandler.isVerified) {
        window.location.href = AppRoutes.HomePage;
      }
    }
  }, [notEnoughField, userInfo.isLogged, checkingBillingInformationHandler.isVerified]);

  //! Render
  return (
    <div
      className='component:WarningUpdateBillingInfoPage p-2'
      style={{
        width: '100vw',
        height: '100vh',
        overflow: 'auto',
        backgroundColor: 'var(--bg-color-main)',
      }}
    >
      <Formik
        validationSchema={validationProfile}
        validateOnBlur={false}
        validateOnChange={false}
        initialValues={{
          ...UserModel.initialProfileUser(userInfo),
        }}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {(propsFormik) => (
          <Form
            className='d-flex mobile:flex-column'
            style={{ justifyContent: 'space-evenly', paddingTop: isMobile ? 12 : 90 }}
          >
            <div style={{ maxWidth: 600, marginBottom: isMobile ? 12 : 0 }}>
              <NewDesign.Typography component='h3'>
                Dear <b>{userInfo?.username}</b>,
              </NewDesign.Typography>
              <NewDesign.Typography component='h5' className='mt-3' style={{ lineHeight: 1.5 }}>
                We regret to inform you that your billing information is incomplete. Due to this,
                you are currently unable to continue utilizing all the features and services
                provided by our platform.
              </NewDesign.Typography>

              <NewDesign.Typography component='h5' className='mt-3' style={{ lineHeight: 1.5 }}>
                We encourage you to complete your info as soon as possible so that you can continue
                to enjoy our platform without any disruption. We also ensure you that our payment
                options are fast, secure, and convenient for your use.
              </NewDesign.Typography>

              <NewDesign.Typography component='h5' className='mt-3' style={{ lineHeight: 1.5 }}>
                We appreciate your patience and understanding, and we apologize for any
                inconvenience this may have caused. Your continued support and patronage are very
                important to us.
              </NewDesign.Typography>

              <NewDesign.Typography component='h5' className='mt-3' style={{ lineHeight: 1.5 }}>
                Thank you for choosing our platform!
              </NewDesign.Typography>
            </div>

            <div style={{ maxWidth: 800 }} className='default-border p-3 flex-shrink-0'>
              <Profile hidePersonalInformation />

              <div className='d-flex justify-content-end'>
                <NewDesign.Button variant='text' color='danger' onClick={logout}>
                  <CommonIcons.SignOut /> Logout
                </NewDesign.Button>

                {!checkingBillingInformationHandler.isInProgress && (
                  <NewDesign.Button
                    type='submit'
                    className='ml-3'
                    isLoading={propsFormik.isSubmitting}
                  >
                    Update
                  </NewDesign.Button>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

WarningUpdateBillingInfoPage.propTypes = propTypes;
export default (props) => {
  return (
    <CheckingBillingInformationProvider>
      <WarningUpdateBillingInfoPage {...props} />
    </CheckingBillingInformationProvider>
  );
};
